import { useFederatedComponent } from 'modules/app-registry/hooks/useFederatedComponent'
import { WidgetComponent } from 'modules/desktop/modules/widgets/types/widgets.types'

import { WidgetWrapper } from '../../../WidgetWrapper'
import { CalendarLargeWidgetProps } from './CalendarLargeWidget.types'

export const CalendarLargeWidget: WidgetComponent<CalendarLargeWidgetProps> = ({
  showAddEventButton,
  ...widgetProps
}) => {
  const { module, isLoaded, isError, missingRemoteUrl } = useFederatedComponent(
    process.env.REACT_APP_CALENDAR_APP_DEV_PATH,
    'calendar',
    './CalendarLargeWidget',
    'calendarApp'
  )

  // @ts-expect-error: dynamic import
  const { CalendarLargeWidgetExposed: CalendarLargeExposedWidget } =
    isLoaded && !isError && !missingRemoteUrl && module
      ? module
      : {
          CalendarLargeWidgetExposed: () => <></>
        }

  return (
    <WidgetWrapper {...widgetProps} hasFullView={true} isLoading={!isLoaded}>
      <CalendarLargeExposedWidget showAddEventButton={showAddEventButton} />
    </WidgetWrapper>
  )
}
